<form class="g-3 needs-validation" novalidate [formGroup]="formFields" (ngSubmit)="onSubmit()">
  <div class="form_sections">
    <h4><u>Claims History Relating to the Horse Proposed for this Insurance</u></h4>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label>Have you made any claims for {{ stableName }} in the last 3 years? <span class="text-danger">*</span></label>
          <mat-select
            formControlName="proposed_horse_has_claims"
            class="form-control form-control-sm w-100"
            name="proposed_horse_has_claims"
            required
            [ngClass]="{ 'is-invalid': (f.proposed_horse_has_claims.touched || submitted) && f.proposed_horse_has_claims.errors?.required }"
          >
            <mat-option [value]="">Select</mat-option>
            <mat-option [value]="1">Yes</mat-option>
            <mat-option [value]="0">No</mat-option>
          </mat-select>
          <div class="invalid-feedback" *ngIf="(f.proposed_horse_has_claims.touched || submitted) && f.proposed_horse_has_claims.errors?.required">
            This field is required.
          </div>
        </div>
      </div>
    </div>

    <div formArrayName="proposed_horse_claims" *ngIf="formFields.get('proposed_horse_has_claims').value === 1 || formFields.get('proposed_horse_has_claims').value === '1'">
      <div *ngFor="let claim of proposedClaims.controls; let i = index" [formGroupName]="i" class="border rounded p-3 mb-3">
        <h5 class="mb-3" *ngIf="proposedClaims.length > 1">Claim {{ i + 1 }}</h5>
        <div class="row mb-3">
          <div class="col-md-6">
            <label>What was the date of the claim (to the best of your memory)? <span class="text-danger">*</span></label>
            <div class="form-group w-100">
              <input
                type="text"
                required
                [attr.name]="'proposed_claim_date_' + i"
                formControlName="claim_date"
                placeholder="What was the date of the claim (to the best of your memory)?"
                class="form-control form-control-sm datepicker"
                matInput
                (focus)="proposedClaimDatepicker.open()"
                [matDatepicker]="proposedClaimDatepicker"
                (dateChange)="onClaimDateChange($event, i, 'proposed')"
                [ngClass]="{
                  'is-invalid':
                    (claim.get('claim_date').touched || submitted) &&
                    claim.get('claim_date').errors?.required
                }"
              />
              <mat-datepicker-toggle [for]="proposedClaimDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #proposedClaimDatepicker></mat-datepicker>
              <div
                class="invalid-feedback"
                *ngIf="
                  (claim.get('claim_date').touched || submitted) &&
                  claim.get('claim_date').errors?.required
                "
              >
                Claim date is required.
              </div>
            </div>
            <small class="form-text text-white">This should be the onset date of the condition and not the date that the claim was submitted or settled.</small>
          </div>
          <div class="col-md-6">
            <label>What type of claim was it? <span class="text-danger">*</span></label>
            <mat-select
              formControlName="claim_type"
              class="form-control form-control-sm w-100"
              [ngClass]="{ 'is-invalid': (claim.get('claim_type').touched || submitted) && claim.get('claim_type').errors?.required }"
            >
              <mat-option [value]="">Select</mat-option>
              <mat-option *ngFor="let opt of proposedClaimTypes" [value]="opt.id">{{ opt.name }}</mat-option>
            </mat-select>
            <div class="invalid-feedback" *ngIf="(claim.get('claim_type').touched || submitted) && claim.get('claim_type').errors?.required">
              Claim type is required.
            </div>
          </div>
        </div>
        <div class="row mb-3" *ngIf="isOtherClaimTypeSelected(i, 'proposed')">
          <div class="col-md-12">
            <label>Please specify (other claim type). <span class="text-danger">*</span></label>
            <input
              type="text"
              formControlName="other_claim"
              class="form-control form-control-sm"
              placeholder="Other claim type"
              [ngClass]="{ 'is-invalid': (claim.get('other_claim').touched || submitted) && claim.get('other_claim').errors?.required }"
            />
            <div class="invalid-feedback" *ngIf="(claim.get('other_claim').touched || submitted) && claim.get('other_claim').errors?.required">
              Please specify the other claim type.
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label>Please briefly confirm the cause of the claim (e.g. laminitis). <span class="text-danger">*</span></label>
            <textarea
              formControlName="claim_cause"
              class="form-control form-control-sm"
              rows="2"
              placeholder="Free format text"
              [ngClass]="{ 'is-invalid': (claim.get('claim_cause').touched || submitted) && claim.get('claim_cause').errors?.required }"
            ></textarea>
            <div class="invalid-feedback" *ngIf="(claim.get('claim_cause').touched || submitted) && claim.get('claim_cause').errors?.required">
              Cause of claim is required.
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <label>What is the status of the claim? <span class="text-danger">*</span></label>
            <mat-select
              formControlName="claim_status"
              class="form-control form-control-sm w-100"
              [ngClass]="{ 'is-invalid': (claim.get('claim_status').touched || submitted) && claim.get('claim_status').errors?.required }"
            >
              <mat-option *ngFor="let opt of claimStatusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
            </mat-select>
            <div class="invalid-feedback" *ngIf="(claim.get('claim_status').touched || submitted) && claim.get('claim_status').errors?.required">
              Claim status is required.
            </div>
          </div>
          <div class="col-md-6">
            <label>Please enter the claim settlement amount to date. <span class="text-danger">*</span></label>
            <input
              type="number"
              formControlName="settlement_amount"
              class="form-control form-control-sm"
              placeholder="£"
              min="0"
              step="0.01"
              [ngClass]="{ 'is-invalid': (claim.get('settlement_amount').touched || submitted) && claim.get('settlement_amount').errors?.required }"
            />
            <div class="invalid-feedback" *ngIf="(claim.get('settlement_amount').touched || submitted) && claim.get('settlement_amount').errors?.required">
              Settlement amount is required.
            </div>
            <small class="form-text text-white">If your claim has not yet been settled, please enter the value of the claim you have submitted.</small>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-6 d-flex align-items-end" [ngClass]="{ 'offset-md-6': i < proposedClaims.length - 1 }">
            <button type="button" class="btn btn-outline-secondary btn-sm mr-2" *ngIf="i === proposedClaims.length - 1" (click)="addProposedClaim()">Add another claim</button>
            <button type="button" class="btn btn-outline-danger btn-sm" *ngIf="proposedClaims.length > 1" (click)="removeProposedClaim(i)">Remove this claim</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form_sections mt-4">
    <h4><u>Claims History Relating to Other Horses</u></h4>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label>Have you made any claims in the last 3 years for any OTHER horses not proposed for this insurance? <span class="text-danger">*</span></label>
          <mat-select
            formControlName="other_horses_has_claims"
            class="form-control form-control-sm w-100"
            name="other_horses_has_claims"
            required
            [ngClass]="{ 'is-invalid': (f.other_horses_has_claims.touched || submitted) && f.other_horses_has_claims.errors?.required }"
          >
            <mat-option [value]="">Select</mat-option>
            <mat-option [value]="1">Yes</mat-option>
            <mat-option [value]="0">No</mat-option>
          </mat-select>
          <div class="invalid-feedback" *ngIf="(f.other_horses_has_claims.touched || submitted) && f.other_horses_has_claims.errors?.required">
            This field is required.
          </div>
        </div>
      </div>
    </div>

    <div formArrayName="other_horses_claims" *ngIf="formFields.get('other_horses_has_claims').value === 1 || formFields.get('other_horses_has_claims').value === '1'">
      <div *ngFor="let claim of otherHorsesClaims.controls; let i = index" [formGroupName]="i" class="border rounded p-3 mb-3">
        <h5 class="mb-3" *ngIf="otherHorsesClaims.length > 1">Claim {{ i + 1 }}</h5>
        <div class="row mb-3">
          <div class="col-md-6">
            <label>What was the date of the claim (to the best of your memory)? <span class="text-danger">*</span></label>
            <div class="form-group w-100">
              <input
                type="text"
                required
                [attr.name]="'other_horse_claim_date_' + i"
                formControlName="claim_date"
                placeholder="What was the date of the claim (to the best of your memory)?"
                class="form-control form-control-sm datepicker"
                matInput
                (focus)="otherHorseClaimDatepicker.open()"
                [matDatepicker]="otherHorseClaimDatepicker"
                (dateChange)="onClaimDateChange($event, i, 'other')"
                [ngClass]="{
                  'is-invalid':
                    (claim.get('claim_date').touched || submitted) &&
                    claim.get('claim_date').errors?.required
                }"
              />
              <mat-datepicker-toggle [for]="otherHorseClaimDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #otherHorseClaimDatepicker></mat-datepicker>
              <div
                class="invalid-feedback"
                *ngIf="
                  (claim.get('claim_date').touched || submitted) &&
                  claim.get('claim_date').errors?.required
                "
              >
                Claim date is required.
              </div>
            </div>
            <small class="form-text text-white">This should be the onset date of the condition and not the date that the claim was submitted or settled.</small>
          </div>
          <div class="col-md-6">
            <label>What type of claim was it? <span class="text-danger">*</span></label>
            <mat-select
              formControlName="claim_type"
              class="form-control form-control-sm w-100"
              [ngClass]="{ 'is-invalid': (claim.get('claim_type').touched || submitted) && claim.get('claim_type').errors?.required }"
            >
              <mat-option [value]="">Select</mat-option>
              <mat-option *ngFor="let opt of otherClaimTypes" [value]="opt.id">{{ opt.name }}</mat-option>
            </mat-select>
            <div class="invalid-feedback" *ngIf="(claim.get('claim_type').touched || submitted) && claim.get('claim_type').errors?.required">
              Claim type is required.
            </div>
          </div>
        </div>
        <div class="row mb-3" *ngIf="isOtherClaimTypeSelected(i, 'other')">
          <div class="col-md-12">
            <label>Please specify (other claim type). <span class="text-danger">*</span></label>
            <input
              type="text"
              formControlName="other_claim"
              class="form-control form-control-sm"
              placeholder="Other claim type"
              [ngClass]="{ 'is-invalid': (claim.get('other_claim').touched || submitted) && claim.get('other_claim').errors?.required }"
            />
            <div class="invalid-feedback" *ngIf="(claim.get('other_claim').touched || submitted) && claim.get('other_claim').errors?.required">
              Please specify the other claim type.
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label>Please briefly confirm the cause of the claim (e.g. laminitis). <span class="text-danger">*</span></label>
            <textarea
              formControlName="claim_cause"
              class="form-control form-control-sm"
              rows="2"
              placeholder="Free format text"
              [ngClass]="{ 'is-invalid': (claim.get('claim_cause').touched || submitted) && claim.get('claim_cause').errors?.required }"
            ></textarea>
            <div class="invalid-feedback" *ngIf="(claim.get('claim_cause').touched || submitted) && claim.get('claim_cause').errors?.required">
              Cause of claim is required.
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <label>What is the status of the claim? <span class="text-danger">*</span></label>
            <mat-select
              formControlName="claim_status"
              class="form-control form-control-sm w-100"
              [ngClass]="{ 'is-invalid': (claim.get('claim_status').touched || submitted) && claim.get('claim_status').errors?.required }"
            >
              <mat-option *ngFor="let opt of claimStatusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
            </mat-select>
            <div class="invalid-feedback" *ngIf="(claim.get('claim_status').touched || submitted) && claim.get('claim_status').errors?.required">
              Claim status is required.
            </div>
          </div>
          <div class="col-md-6">
            <label>Please enter the claim settlement amount to date. <span class="text-danger">*</span></label>
            <input
              type="number"
              formControlName="settlement_amount"
              class="form-control form-control-sm"
              placeholder="£"
              min="0"
              step="0.01"
              [ngClass]="{ 'is-invalid': (claim.get('settlement_amount').touched || submitted) && claim.get('settlement_amount').errors?.required }"
            />
            <div class="invalid-feedback" *ngIf="(claim.get('settlement_amount').touched || submitted) && claim.get('settlement_amount').errors?.required">
              Settlement amount is required.
            </div>
            <small class="form-text text-white">If your claim has not yet been settled, please enter the value of the claim you have submitted.</small>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-6 d-flex align-items-end" [ngClass]="{ 'offset-md-6': i < otherHorsesClaims.length - 1 }">
            <button type="button" class="btn btn-outline-secondary btn-sm mr-2" *ngIf="i === otherHorsesClaims.length - 1" (click)="addOtherHorsesClaim()">Add another claim</button>
            <button type="button" class="btn btn-outline-danger btn-sm" *ngIf="otherHorsesClaims.length > 1" (click)="removeOtherHorsesClaim(i)">Remove this claim</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3" *ngIf="submitted && formFields.invalid">
    <div class="col">
      <div class="alert alert-danger mb-0" role="alert">
        Please complete all required fields above before saving.
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12 d-flex justify-content-between align-items-center">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="GoToPrevTab.emit()">Back</button>
      <div>
        <!-- <button type="button" class="btn btn-outline-secondary btn-sm mr-2" (click)="onSubmit(false)">Save Indicative Quote</button> -->
        <button [disabled]="saving" type="submit" class="btn btn-success btn-sm">Save & Continue</button>
      </div>
    </div>
  </div>
</form>
